var card_default = {
  "link": "usnAt",
  "container": "eeJoh",
  "cardLayout": "OC4su",
  "imageEnd": "ox9RW",
  "imageStart": "_1g-fA",
  "imageTop": "-p3Az",
  "right": "iR99-",
  "ltr": "aab-6",
  "rtl": "ufzth",
  "imageContainer": "Y7lhX",
  "image": "IIVrD",
  "responsiveImage": "_8gF4W",
  "squareImage": "F0alx",
  "rectangleImage": "csm4d",
  "squareRatio": "kCjxj",
  "rectangleRatio": "xFjng",
  "imageFill": "PpCXO",
  "imageFit": "pE1Eu",
  "imageRibbon": "JnjLg"
};
export {
  card_default as default
};
//# sourceMappingURL=card-scss.js.map
